export enum EBatchType {
  legacyUpload = 0,
  unusedFeelFreeToReuseThisType = 1,
  fileUpload = 2,
  robotUpload = 3
}
